import moment from 'moment';

export const formatRequestDate = (date: moment.Moment): string => date.format('YYYY-MM-DD');

export const isoStringDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ';
